import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationSlugEnum } from '@app/generated/graphql';
import * as Sentry from '@sentry/browser';

interface IActionMap {
  actionLabel: string;
  action: (metadata: any) => void;
}

@Injectable({ providedIn: 'root' })
export class NotificationActionService {
  // dependencies
  private _router = inject(Router);

  // configuration around the action to be taken when a notification is triggered
  private _actionMap: Record<NotificationSlugEnum, IActionMap> = {
    // This example slug will be used strictly for testing purposes
    [NotificationSlugEnum.Example]: {
      actionLabel: 'View Order',
      action: (metadata: Record<string, any>) => {
        // navigate the user to the associated order
        const orderId: string = metadata['changes_by_entity'][0]['entity_id'];

        this._router.navigate(['/account/order', orderId]);
      },
    },
  };

  // execute the action associated with the notification rule slug
  public executeAction(
    metadata: Record<string, any>,
    notificationRuleSlug: NotificationSlugEnum,
  ): void {
    const entry: IActionMap | undefined = this._actionMap[notificationRuleSlug];

    if (!entry?.action) {
      return;
    }
    try {
      entry.action(metadata);
    } catch (error) {
      console.error('Error executing action', error);
      Sentry.captureException(error);
    }
  }

  // get the action label associated with the notification rule slug
  public getActionLabel(notificationRuleSlug: NotificationSlugEnum): string {
    return this._actionMap[notificationRuleSlug]?.actionLabel ?? '';
  }
}
